import { ColDef } from '@ag-grid-enterprise/all-modules'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'
import { AgGridColumnType, AgGridExportType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'
import { ModuleOperationGuard } from '@/api/operations/guards/module-operation-guard'

const grossingGridSampleTakeOutFromArchivoChildrenColumnDefs = (): (ColDef | ExportedColDef)[] => ([
    {
        headerName: i18n.tc('grossing.grid.sampleLabel'),
        field: 'samLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        useForGeneratingBarcodeInExports: true,
        width: 140,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('registry.requestGrid.subGrid.location'),
        field: 'topographicCode.description',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('global.sampleType'),
        field: 'sampleType.description',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('grossing.sidebar.grossingDate'),
        field: 'lastGrossingDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        width: 110,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('grossing.grid.lastGrossingResponsible'),
        colId: 'responsibleForLastGrossing.normalizedFullName',
        field: 'responsibleForLastGrossing.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 160,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('grid.detail.casStatusId'),
        field: 'status',
        type: AgGridColumnType.GROSSING_SAMPLE_STATUS,
        exportField: 'status.name',
        exportType: AgGridExportType.TEXT,
        width: 110,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('archive.grid.archiveLocation'),
        colId: 'locationLabel',
        field: 'archivingLocation',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        width: 110,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('grid.hasAlarms'),
        headerTooltip: i18n.tc('grid.hasAlarms'),
        field: 'incidents',
        type: AgGridColumnType.INCIDENT,
        exportType: AgGridExportType.INTEGER,
        filter: false,
        hide: true,
        width: 55,
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-exclamation-triangle')
        }
    },
    {
        headerName: i18n.tc('grid.attachments'),
        headerTooltip: i18n.tc('grid.attachments'),
        field: 'attachments',
        type: AgGridColumnType.ATTACHMENT_COUNT,
        exportType: AgGridExportType.INTEGER,
        headerComponentParams: {
            template: buildIconHeaderTemplate('far fa-paperclip')
        }
    }
])

export const grossingGridSampleTakeOutFromArchiveColumnDefs = ():(ColDef | ExportedColGroupDef)[] => ([
    { type: AgGridColumnType.CUSTOM_CHECKBOX },
    {
        headerName: i18n.tc('entities.sample.sample'),
        children: ModuleOperationGuard.canAccessBilling
            ? grossingGridSampleTakeOutFromArchivoChildrenColumnDefs().concat([{
                type: AgGridColumnType.HAS_UNAUTHORIZED_BILLABLE_CONCEPTS,
                exportType: AgGridExportType.BOOLEAN,
                field: 'hasUnauthorizedBillableConcepts',
                flex: 1,
                minWidth: 55
            }])
            : grossingGridSampleTakeOutFromArchivoChildrenColumnDefs()
    },
    {
        headerName: i18n.tc('entities.case.case'),
        children: [
            {
                headerName: i18n.tc('grid.detail.studyId'),
                field: 'caseStudy.casCasenumber',
                type: AgGridColumnType.TEXT,
                exportType: AgGridExportType.TEXT,
                width: 110,
                suppressSizeToFit: true
            },
            {
                headerName: i18n.tc('global.priority'),
                colId: 'caseStudy.priority.level',
                field: 'caseStudy.priority',
                type: AgGridColumnType.PRIORITY,
                exportField: 'caseStudy.priority.name',
                exportType: AgGridExportType.TEXT
            },
            {
                headerName: i18n.tc('registry.btn.consultation'),
                headerTooltip: i18n.tc('registry.btn.consultation'),
                field: 'caseStudy.caseOfReference',
                type: AgGridColumnType.TEXT,
                exportType: AgGridExportType.BOOLEAN,
                filter: false,
                hide: false,
                headerComponentParams: {
                    template: buildIconHeaderTemplate('far fa-glasses')
                },
                cellRenderer: ({ value }: ICellRendererParams) => value === true ? '<i class="success far fa-check"/>' : ''
            }]
    }
])
